import { Create, SimpleForm } from "react-admin";

import RelayEventFormFields, {
  transformRelayEventPayload,
  validateRelayEventForm,
} from "./RelayEventFormFields";

const RelayEventCreate = () => (
  <Create redirect="list" transform={transformRelayEventPayload}>
    <SimpleForm
      warnWhenUnsavedChanges
      validate={validateRelayEventForm}
      defaultValues={{
        isActive: true,
        isLive: false,
        castEnabled: false,
        singleSessionEnabled: false,
        isDefault: false,
        requiresAccessGrant: false,
        otpRequired: false,
      }}
      sx={{ maxWidth: 640, width: "100%" }}
    >
      <RelayEventFormFields />
    </SimpleForm>
  </Create>
);

export default RelayEventCreate;
